// src/components/Contacts/Contacts.js
import React from 'react';
import './Contacts.css';

const SOCIAL_ICON_BASE = `${process.env.PUBLIC_URL}/images/social`;

function Contacts() {
    return (
        <section id="contacts" className="contacts" aria-labelledby="contacts-title">
            <div className="container">
                <div className="contacts-heading">
                    <p className="section-kicker">Остаёмся на связи</p>
                    <h2 id="contacts-title">Следующий дроп — сначала в соцсетях.</h2>
                </div>
                <div className="social-links">
                    <a
                        href="https://t.me/itismyrussia"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        aria-label="Telegram — ЭТО РОССИЯ"
                    >
                        <img
                            src={`${SOCIAL_ICON_BASE}/telegram.png`}
                            alt="Telegram"
                            className="social-icon"
                            width={48}
                            height={48}
                            loading="lazy"
                        />
                        <span><strong>Telegram</strong><small>@itismyrussia</small></span>
                    </a>
                    <a
                        href="https://vk.ru/eto_russia_rostov"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        aria-label="ВКонтакте — ЭТО РОССИЯ"
                    >
                        <img
                            src={`${SOCIAL_ICON_BASE}/vk.png`}
                            alt="ВКонтакте"
                            className="social-icon"
                            width={48}
                            height={48}
                            loading="lazy"
                        />
                        <span><strong>ВКонтакте</strong><small>ЭТО РОССИЯ</small></span>
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Contacts;
